<template>
  <canvas :id="'myChart' + id"></canvas>
</template>

<script>
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
 name: "PassengerTrafficRoadTransport",
 props: {
  receivedData: {
    type: [Object, Array],
    required: true
  },
  graphType: {
    type: [String],
    default: 'bar'
  },
  indexAxis: {
    type: String,
    default: 'x'
  },
  id: {
    type: String,
    required: true
  },
  dataLabels: {
    type: Boolean,
    default: false
  },
  maintainAspectRatio: {
    type: Boolean,
    default: false
  },
  aspectRatio: {
    type: Number,
    default: 1
  },
  isTtile: {
    type: Boolean,
    default: true
  }
 },

 mounted() {
   const ctx = document.getElementById("myChart" + this.id);
   Chart.register(ChartDataLabels)
   const myChart = new Chart(ctx, {
       type: this.graphType,
       data: this.graphicData,
       options: this.options

   })
 },

 computed: {
  options () {
    return  {
      indexAxis: this.indexAxis,
      plugins: this.plugins,
      maintainAspectRatio: this.maintainAspectRatio, 
      aspectRatio: this.aspectRatio
    }
  },
  plugins () {
    return {
      datalabels: {
        align: true,
        display: this.dataLabels,
        textAlign: 'start',
        anchor: 'start',
        font: {
          size: 14,
          weight: 600
        }
      },
      legend: {
        labels: {
          usePointStyle: true,
        },
        position: 'top',
      },
      title: {
        display:this.isTitle,
        text: this.receivedData.title,
        font: {
          size: 14
        }
      }
    }
  },

  datasets () {
    return this.getDataset(this.receivedData)
  },
  
  graphicData () {
    return {
      labels: this.finalData.labelsY,
      datasets: this.datasets
    }
  },

  finalData () {
    return this.getFinalData()
  },
 },

 methods: {
  getDataset (data) {
    let newDataSet = []
    let labelsX = data.labels

    Object.keys(labelsX).forEach((item) => {
      newDataSet.push({
          label: labelsX[item].name,
          backgroundColor: labelsX[item].color,
          borderColor: labelsX[item].color,
          data: this.finalData.trafficData[item],
          xAxisID: "bar-x-axis2",
          stack: "background"
        })
    })

    return newDataSet
  },

  getFinalData () {
    let trafficData = this.receivedData.data
    let newTrafficData = {}
    let labelsY = []
    let labelsX = this.receivedData.labels
  

    Object.keys(labelsX).forEach((item) => {
      newTrafficData[item] = []
      trafficData.forEach((itemValue) => {
        let value = itemValue.data.find(val => val.label_id == labelsX[item].id)
        newTrafficData[item].push(value.value)
      })
    })
    labelsY = trafficData.reduce((total, value) => {
        total.push(value.year + "")
        return total
    }, [])

    return {
      trafficData: newTrafficData,
      labelsY: labelsY
    }
  },

  getYears () {

  }
 }
}
</script>


<style scoped>
.parent_chart{
  width: 50%;
}

#myChart {
  width: 500px;
}
</style>